import AccessDeniedPage from "pages/AccessDeniedPage"
import AdminAuxEquipment from "pages/AdminUI/AdminAuxEquipment/AdminAuxEquipment"
import AdminCriteriaCatalogs from "pages/AdminUI/AdminCriteriaCatalog/AdminCriteriaCatalogs"
import AdminDeviceDataGroups from "pages/AdminUI/AdminDeviceData/AdminDeviceGroups"
import AdminExaminationConfig from "pages/AdminUI/AdminExaminationConfig/AdminExaminationConfig"
import AdminLaboratories from "pages/AdminUI/AdminLaboratories/AdminLaboratories"
import AdminNorms from "pages/AdminUI/AdminNorms/AdminNorms"
import AdminRootLayout from "pages/AdminUI/AdminRootLayout"
import AdminSkillManagement from "pages/AdminUI/AdminSkillManagement/AdminSkillManagement"
import AdminTasks from "pages/AdminUI/AdminTasks/AdminTasks"
import AdminTestEquipment from "pages/AdminUI/AdminTestEquipment/AdminTestEquipment"
import AdminTextBlocks from "pages/AdminUI/AdminTextBlocks/AdminTextBlocks"
import AdminUIDashboard from "pages/AdminUI/AdminUIDashboard"
import { AuditTrailPage } from "pages/AuditTrailPage/AuditTrailPage"
import BaseLayout from "pages/BaseLayout/BaseLayout"
import { BaseLayoutDashboard } from "pages/BaseLayout/BaseLayoutDashboard"
import ContactDetailsPage from "pages/Contacts/ContactDetails"
import Contacts from "pages/Contacts/Contacts"
import CreateContactPage from "pages/Contacts/CreateContact"
import CreateCustomerPage from "pages/Customers/CreateCustomer"
import CustomerDetailsPage from "pages/Customers/CustomerDetails"
import Customers from "pages/Customers/Customers"
import Dashboard from "pages/Dashboard/Dashboard"
import { EUTManagement } from "pages/EUTManagement/EUTManagement"
import { ExaminationPage } from "pages/ExaminationPage/ExaminationPage"
import { LoginPage } from "pages/LoginPage/LoginPage"
import Leads from "pages/Projects/Leads"
import { ProjectDetail } from "pages/Projects/ProjectDetail/ProjectDetail"
import Projects from "pages/Projects/Projects"
import { ReportPage } from "pages/ReportPage/ReportPage"
import SalesQuoteDetail from "pages/SalesQuotes/SalesQuoteDetail"
import SalesQuotes from "pages/SalesQuotes/SalesQuotes"
import StockItems from "pages/StockItems/StockItems"
import { TaskPage } from "pages/TaskPage/TaskPage"
import { UsersPage } from "pages/UsersPage/UsersPage"
import { createBrowserRouter, Navigate } from "react-router-dom"
import { ProtectedRoute } from "../components/ProtectedRoute/ProtectedRoute"

export enum AppRoutes {
  HOME = "/dashboard",
  LOGIN = "/login",
  ACCESS_DENIED = "/access-denied",
  USERS = "data/users",
  EXAMINATION = "/examination/:projectID/:examinationID",
  TASK = "/examination/:projectID/:examinationID/tasks",
  AUDIT_TRAIL = "/examination/:projectID/:examinationID/audit_trail",
  FUNCTION_TEST = "/function-test/:projectID/:examinationID/:taskID",
  REPORT = "/report/:projectID/:reportID",

  ADMIN_UI = "/admin",
  ADMIN_TEXT_BLOCKS = "/admin/textblocks",
  ADMIN_DEVICE_DATA = "/admin/devicedata",
  ADMIN_NORMEN = "/admin/norms",
  ADMIN_SKILLMANAGEMNET = "/admin/skillmanagement",
  ADMIN_EXAMINATIONS = "/admin/examinations",
  ADMIN_TASKS = "/admin/tasks",
  ADMIN_TEST_EQUIPMENT = "/admin/testequipment",
  ADMIN_AUX_EQUIPMENT = "/admin/auxequipment",
  ADMIN_LABORATORIES = "/admin/laboratories",
  ADMIN_CRITERIA_CATALOGS = "/admin/criteriacatalogs",
  CONTACTS = "data/contacts",
  CONTACT_DETAIL = "data/contacts/:contactID",
  CREATE_CONTACT = "/create-contact",
  LEADS = "/projectportal/leads",
  CUSTOMERS = "/data/customers",
  CREATE_CUSTOMER = "/data/customers/create",
  CUSTOMER_DETAIL = "/data/customers/:customerID",
  SALES_QUOTES = "/data/salesquotes",
  SALES_QUOTE_DETAIL = "/data/salesquotes/:quoteNbr",
  STOCK_ITEMS = "/data/stockitems",
  PROJECTS = "/projectportal/projects",
  PROJECT_DETAIL = "/projectportal/projects/:projectID",
  EUTMANAGMENT = "/admin/eutmanagement",
}

export const mobileRouter = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to="/projects" replace />,
  },
  {
    path: AppRoutes.LOGIN,
    element: <LoginPage />,
  },
  {
    path: AppRoutes.ACCESS_DENIED,
    element: <AccessDeniedPage />,
  },
  {
    path: AppRoutes.HOME,
    element: <BaseLayoutDashboard />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [{ index: true, element: <Dashboard /> }],
      },
    ],
  },
  {
    path: AppRoutes.EXAMINATION,
    element: <BaseLayout />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [
          { index: true, element: <ExaminationPage /> },
          { path: "tasks", element: <TaskPage /> },
          { path: "audit_trail", element: <AuditTrailPage /> },
        ],
      },
    ],
  },

  {
    path: AppRoutes.EUTMANAGMENT,
    element: (
      <ProtectedRoute>
        <EUTManagement />
      </ProtectedRoute>
    ),
  },
  {
    path: AppRoutes.USERS,
    element: (
      <ProtectedRoute>
        <UsersPage />
      </ProtectedRoute>
    ),
  },
])

export const desktopRouter = createBrowserRouter([
  {
    path: "/",
    element: <Navigate to="/dashboard" replace />,
  },
  {
    path: AppRoutes.LOGIN,
    element: <LoginPage />,
  },
  {
    path: AppRoutes.ACCESS_DENIED,
    element: <AccessDeniedPage />,
  },
  {
    path: AppRoutes.EXAMINATION,
    element: <BaseLayout />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [
          { index: true, element: <ExaminationPage /> },
          { path: "tasks", element: <TaskPage /> },
          { path: "audit_trail", element: <AuditTrailPage /> },
        ],
      },
    ],
  },

  {
    path: AppRoutes.HOME,
    element: <AdminRootLayout />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [{ index: true, element: <Dashboard /> }],
      },
    ],
  },
  {
    path: AppRoutes.REPORT,
    element: <AdminRootLayout />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [{ index: true, element: <ReportPage /> }],
      },
    ],
  },
  {
    path: AppRoutes.LEADS,
    element: <AdminRootLayout />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [{ index: true, element: <Leads /> }],
      },
    ],
  },
  {
    path: AppRoutes.CONTACTS,
    element: <AdminRootLayout />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [
          { index: true, element: <Contacts /> },
          { path: ":contactID", element: <ContactDetailsPage /> },
        ],
      },
    ],
  },
  {
    path: AppRoutes.CUSTOMERS,
    element: <AdminRootLayout />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [
          { index: true, element: <Customers /> },
          {
            path: ":businessAccountID/create-contact",
            element: <CreateContactPage />,
          },
          { path: ":customerID", element: <CustomerDetailsPage /> },
        ],
      },
    ],
  },
  {
    path: AppRoutes.CREATE_CUSTOMER,
    element: <AdminRootLayout />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [{ index: true, element: <CreateCustomerPage /> }],
      },
    ],
  },
  {
    path: AppRoutes.SALES_QUOTES,
    element: <AdminRootLayout />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [
          { index: true, element: <SalesQuotes /> },
          { path: ":quoteNbr", element: <SalesQuoteDetail /> },
        ],
      },
    ],
  },
  {
    path: AppRoutes.STOCK_ITEMS,
    element: <AdminRootLayout />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [{ index: true, element: <StockItems /> }],
      },
    ],
  },
  {
    path: AppRoutes.PROJECTS,
    element: <AdminRootLayout />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [
          { index: true, element: <Projects /> },
          { path: AppRoutes.PROJECT_DETAIL, element: <ProjectDetail /> },
        ],
      },
    ],
  },
  {
    path: AppRoutes.EUTMANAGMENT,
    element: <AdminRootLayout />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [{ index: true, element: <EUTManagement /> }],
      },
    ],
  },
  {
    path: AppRoutes.ADMIN_UI,
    element: <AdminRootLayout />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [
          { index: true, element: <AdminUIDashboard /> },
          {
            path: AppRoutes.ADMIN_DEVICE_DATA,
            element: <AdminDeviceDataGroups />,
          },
          { path: AppRoutes.ADMIN_TEXT_BLOCKS, element: <AdminTextBlocks /> },
          { path: AppRoutes.ADMIN_NORMEN, element: <AdminNorms /> },
          {
            path: AppRoutes.ADMIN_SKILLMANAGEMNET,
            element: <AdminSkillManagement />,
          },
          {
            path: AppRoutes.ADMIN_EXAMINATIONS,
            element: <AdminExaminationConfig />,
          },
          { path: AppRoutes.ADMIN_TASKS, element: <AdminTasks /> },
          {
            path: AppRoutes.ADMIN_TEST_EQUIPMENT,
            element: <AdminTestEquipment />,
          },
          {
            path: AppRoutes.ADMIN_AUX_EQUIPMENT,
            element: <AdminAuxEquipment />,
          },
          {
            path: AppRoutes.ADMIN_LABORATORIES,
            element: <AdminLaboratories />,
          },
          {
            path: AppRoutes.ADMIN_CRITERIA_CATALOGS,
            element: <AdminCriteriaCatalogs />,
          },
        ],
      },
    ],
  },
  {
    path: AppRoutes.USERS,
    element: <AdminRootLayout />,
    children: [
      {
        element: <ProtectedRoute />,
        children: [{ index: true, element: <UsersPage /> }],
      },
    ],
  },
])
